import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

export async function getAll() {
    try {
        const response = await apiGet('core', `roles`);
        return response;
    } catch (e) { }
}


export async function getRoles(id: string) {
    try {
        const response = await apiGet('core', `roles/${id}`);
        return response.content;
    } catch (e) {
        return {};
    }
}

export async function rolesAdd(rolesBody: any) {
    try {
        const response = await apiPost('core', `roles`, rolesBody);
        return response;
    } catch (e) { }
}

export async function rolesUpdate(rolesBody: any, id: string) {
    try {
        const response = await apiPut('core', `roles/${id}`, rolesBody);
        return response;
    } catch (e) { }
}

export async function rolesRemove(id: any) {
    try {
        return await apiDelete('core', `roles/${id}`);
    } catch (e) { }
}